module.exports = __webpack_public_path__ + "img/img_display_1.c2dcd88e.svg";